import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';

class LightboxTrigger extends Component {

    /*
        Expects props of:
        images : array of image paths
        captions: array of strings
        index: int of photo to start on
    */
    
    constructor(props){
        super(props);

        this.state={
            index: this.props.index,
            isOpen: false
        }

        this.images = this.props.images;
        this.captions = this.props.captions;

    }

    //Don't show next/prev arrows if only one image in array
    getNextSrc(index){
        if(this.images.length > 1){
            return this.images[(index + 1) % this.images.length];
        } else {
            return null;
        }
    }

    getPrevSrc(index){
        if(this.images.length > 1){
            return this.images[(index + this.images.length - 1) % this.images.length];
        } else {
            return null;
        }
    }

    render() {
        const {index, isOpen} = this.state;
        
        return (
            <div className={"lightbox-trigger " + this.props.outerClass}>
                <button
                    className={this.props.buttonClass}
                    type="button"
                    onClick={() => this.setState({isOpen: true})}
                >   
                    {this.props.children}
                </button>

                {isOpen &&
                    <Lightbox
                        mainSrc={this.images[index]}
                        imageCaption={this.captions[index]}
                        nextSrc={this.getNextSrc(index)}
                        prevSrc={this.getPrevSrc(index)}
                        onCloseRequest={() => this.setState({ isOpen: false, index: this.props.index })}
                        onMovePrevRequest={() => this.setState({
                            index: (index + this.images.length - 1) % this.images.length,
                        })}
                        onMoveNextRequest={() => this.setState({
                            index: (index + 1) % this.images.length,
                        })}
                    />
                }
            </div>
        );
    }
}

export default LightboxTrigger;



// WEBPACK FOOTER //
// ./src/components/LightboxTrigger/LightboxTrigger.js